<script>
import InputText from 'primevue/inputtext';
import Button from 'primevue/button';
import Card from 'primevue/card';
import SelectButton from 'primevue/selectbutton';

import SecurityService from '../../services/security';
import { required, email } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";

export default{
    setup: () => ({ v$: useVuelidate() }),
    props: [''],
    components: {InputText,Button,Card,SelectButton},
    data(){
        return{
            disabled: false,
            submitted: false,
            formData: {
                username: '',
                email: ''
            },
            selectedLanguage: this.$store.state.security.language,
            languages: [ 
                {name: 'English', code: 'en'},
                {name: 'Italiano', code: 'it'}
            ],
        }
    },
    mounted(){
    },
    validations(){
        return {
            formData: {
                username: {required},
                email: {required, email}
            }
        }
    },
    computed: {},
    methods: {
        setLanguage(e){
            this.$store.dispatch("security/setLanguage", e.value);
            this.$root.$i18n.changeLocale(this.$store.state.security.language);
        },
        onSubmit(valid) {
            this.submitted = true;
            if (valid) {
                this.disabled = true;
                this.$store.dispatch("generic/setLoading", true);
                SecurityService.selfResetPassword(this.formData, response => {
                    this.$store.dispatch("generic/setLoading", false);
                    this.disabled = false;
                    if(response.success){
                        this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('changePassword.resetPasswordSuccessMessage'), life: 3000});     
                        this.formData.email = "";
                        this.formData.username = "";
                        this.submitted = false;
                    }else{
                        this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                    }
                });
            }
        }
    },
}    
</script>

<template>
<main>

    <Card style="width: 20rem; margin: 0 auto;">
        <template #title>
            {{$t('resetPassword')}}
        </template>
        <template #content>
            <form @submit.prevent="onSubmit(!v$.$invalid)">
                <div class="formgrid m-2">
                    <div class="my-3">
                        <span class="p-float-label" >
                            <InputText id="username" type="text" v-model="formData.username" :class="{'p-invalid':v$.formData.username.$invalid && submitted, 'w-full': true}"/>
                            <label for="username">{{$t('users.username')}}</label>
                        </span>
                        <small v-if="(v$.formData.username.$invalid && submitted) || v$.formData.username.$pending.$response" class="p-error">{{v$.formData.username.required.$message.replace('Value', 'Username')}}</small>
                    </div>
                    <div class="my-3">
                        <span class="p-float-label" >
                            <InputText id="email" type="text" v-model="formData.email" :class="{'p-invalid':v$.formData.email.$invalid && submitted, 'w-full': true}"/>
                            <label for="email">{{$t('users.email')}}</label>
                        </span>
                        <div v-if="(v$.formData.email.$invalid && submitted) || v$.formData.email.$pending.$response">
                        <small class="p-error" v-for="error in v$.formData.email.$silentErrors" :key="error.$validator">
                            {{error.$message}}
                        </small>
                        </div>
                        <div class="w-full" style="width:220px;color:gray;font-size:11px;margin-top:16px;">
                            {{$t('changePassword.forgotPasswordMessage')}}
                        </div>
                    </div>
                    <div class="my-3" style="text-decoration: none;">
                        <router-link to="/login">{{$t('changePassword.returnLogin')}}</router-link>
                    </div>
                    <div class="" style="text-align: center;">                    
                        <SelectButton v-model="selectedLanguage" :options="languages" optionLabel="name" optionValue="code" @change="setLanguage" />  
                    </div>
                </div>
            </form>
        </template> 
            
         <template #footer> 
            <Button icon="pi pi-check" class="w-full" :disabled="disabled" :label="$t('btn.reset')" type="submit" @click="onSubmit(!v$.$invalid)"/>
        </template>
    </Card>
</main>
</template>